import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, children, className = '', disableOverlayClose = false }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleOverlayMouseDown = (e) => {
    if (disableOverlayClose || !overlayRef.current) return;
    if (e.target === overlayRef.current) {
      overlayRef.current.dataset.backdropClick = 'pending';
    }
  };

  const handleOverlayMouseUp = (e) => {
    if (disableOverlayClose || !overlayRef.current) return;
    const overlay = overlayRef.current;
    if (e.target === overlay && overlay.dataset.backdropClick === 'pending') {
      onClose();
    }
    delete overlay.dataset.backdropClick;
  };

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      ref={overlayRef}
      className="kbh-modal-overlay"
      onMouseDown={disableOverlayClose ? undefined : handleOverlayMouseDown}
      onMouseUp={disableOverlayClose ? undefined : handleOverlayMouseUp}
    >
      <div className={`kbh-modal-content ${className}`} onMouseDown={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal; 